import { useRef, useState } from "react";
import { API_CALLS } from "../../../../../API/api_calls";
import { API_STATUS } from "../../../../../redux/common";
import { ArticleProps } from "../../../../../redux/slices/article/Article";
import { validFile, validImageFileTypes } from "../../../../../utils";
import { HiddenInput } from "../../../../Common/AudioBackground/style";
import { useFindContent } from "../../useFindContent";
import { ContentProps } from "../Content";
import ImageGallery from "./imageGallery";
import ImagePreview from "./ImagePreview";
import Upload from "./upload";

const Image = ({ id }: ContentProps.CommonProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const {
    post_id,
    content_type,
    article_order,
    content_data,
    id: order_id,
    row_config,
  } = useFindContent(id) as ArticleProps.WithImageContent;
  const [isPreviewOpen, setIsPreviewOpen] = useState(content_data?.length > 0);
  const [uploadedImages, setUploadedImages] = useState(0);
  const [api_status, setApi_status] = useState<API_STATUS>("idle");

  return (
    <>
      {isPreviewOpen ? (
        <ImagePreview id={id} setIsPreviewOpen={setIsPreviewOpen} />
      ) : content_data?.length > 0 || uploadedImages > 0 ? (
        <ImageGallery
          id={id}
          fileInputRef={fileInputRef}
          setIsPreviewOpen={setIsPreviewOpen}
          api_status={api_status}
          uploadedImages={uploadedImages}
        />
      ) : (
        <Upload
          fileInputRef={fileInputRef}
          id={id}
          setUploadedImages={setUploadedImages}
          setApi_status={setApi_status}
        />
      )}

      <HiddenInput
        type="file"
        disabled={false}
        multiple
        onChange={(e) => {
          const files = e.target.files;
          if (!files?.length) return;
          const validFiles = validFile(files);
          if (!validFiles.length) return;
          setUploadedImages(validFiles.length);
          API_CALLS.ARTICLE.createOrUpdateArticleContent(
            {
              post_id,
              content_type,
              content_id: String(order_id),
              element_role: row_config.element_role,
              article_order,
              image: validFiles,
            },
            setApi_status
          ).then(() => setUploadedImages(0));
          e.target.value = "";
        }}
        ref={fileInputRef}
        accept={validImageFileTypes.join(",")}
      />
    </>
  );
};

export default Image;
